import { FilledButton } from '../util/button';
import './repairPickUpConfirm.css';

interface RepairPickUpConfirmProps {
  repairItemInfo: {
    label: string;
    value: string;
  }[];
  onClick: () => void;
}
export const RepairPickUpConfirm = ({
  repairItemInfo,
  onClick,
}: RepairPickUpConfirmProps) => {
  return (
    <div className={'pick-up-reserve-confirm-field'}>
      <div className={'reserve-confirm-info-field'}>
        {repairItemInfo.map((item, idx) => (
          <div className={'confirm-info-item'} key={idx}>
            <div className={'info-label'}>{item.label}</div>
            <div className={'info-value'}>{item.value}</div>
          </div>
        ))}
      </div>
      <div className={'reserve-confirm-button-field'}>
        <FilledButton onClick={onClick} label={'返却日を予約する'} />
      </div>
    </div>
  );
};
